import React from "react";


export const OperationTypeFilterContext = React.createContext({
    selected: [],
    setSelected: (operationTypes) => {},
    toggle: (operationType) => {},
    asParams: {}
})